import React, { useState } from "react"
import { Box } from "@mui/material"
import "./ProgressBar.css"

// Battle-pass progress bar. Pure presentation — the parent passes
// `levels` (sorted asc by minXp), `totalXp`, `lastClaimedLevel`, plus an
// `onClaimClick(level)` callback fired when the user taps a reward nut.
export default function ProgressBar({ levels, totalXp, lastClaimedLevel, onClaimClick }) {
    const [flyingLevel, setFlyingLevel] = useState(null)
    if (!levels || levels.length === 0) {
        return <Box className="xp-bar"><div className="xp-bar__fill" style={{ width: "0%" }} /></Box>
    }
    const maxXp = levels[levels.length - 1].minXp
    const fillPct = Math.min(100, Math.max(0, (totalXp / maxXp) * 100))

    function handleClick(level) {
        if (flyingLevel != null) return
        setFlyingLevel(level.level)
        // Allow the fly animation to play before we hand off to claim+celebration.
        setTimeout(() => {
            setFlyingLevel(null)
            if (onClaimClick) onClaimClick(level)
        }, 700)
    }

    return (
        <Box className="xp-bar">
            <div className="xp-bar__fill" style={{ width: `${fillPct}%` }} />

            {/* Inner dividers — for each level except the last (last lives at 100% / right edge). */}
            {levels.slice(0, -1).map(l => {
                const left = (l.minXp / maxXp) * 100
                return <div key={`div-${l.id}`} className="xp-bar__divider" style={{ left: `${left}%` }} />
            })}

            {/* Reward nuts — at thresholds reached but not yet claimed. */}
            {levels.map(l => {
                const reached = totalXp >= l.minXp
                const claimed = l.level <= lastClaimedLevel
                if (!reached || claimed) return null
                const left = (l.minXp / maxXp) * 100
                const isFlying = flyingLevel === l.level
                return (
                    <button
                        key={`reward-${l.id}`}
                        type="button"
                        className={`xp-bar__nut-reward${isFlying ? " is-flying" : ""}`}
                        style={{ left: `${left}%` }}
                        onClick={() => handleClick(l)}
                        title={`Claim +${l.rewardBelcoins} belcoins`}
                    >
                        <img src="/mascotes/Nut_reward.svg" alt="claim reward" draggable="false" />
                        <span className="xp-bar__nut-reward-label">take me!</span>
                    </button>
                )
            })}

            {/* Current-XP marker — always visible. Reward nuts have higher z-index when they overlap. */}
            <img
                className="xp-bar__nut-current"
                src="/mascotes/Nut.svg"
                alt="current progress"
                draggable="false"
                style={{ left: `${fillPct}%` }}
            />
        </Box>
    )
}
